// extracted by mini-css-extract-plugin
module.exports = {"blankSlateRow":"BlankSlate_blankSlateRow__h6JTC","blankSlateCell":"BlankSlate_blankSlateCell__98Jvv","blankSlateError":"BlankSlate_blankSlateError__dUBLp"};